import { useTranslation } from 'react-i18next';
import type { Price } from '@/components/content/welcomeModal/adacUpsell/model';

export const usePriceFormatterHook = () => {
  const { i18n } = useTranslation();
  const formatPrice = ({ amount, currency }: Price) =>
    new Intl.NumberFormat(i18n.language, { style: 'currency', currency }).format(amount);
  const formatPercent = (value: number) =>
    new Intl.NumberFormat(i18n.language, { style: 'percent', maximumFractionDigits: 0 }).format(value);

  return { formatPrice, formatPercent };
};
